import React from "react";
import { ChevronDown, Filter, Search } from "lucide-react";

interface ObjectionFiltersProps {
  searchTerm: string;
  statusFilter: string;
  selectedDate: string;
  visibleCount: number;
  totalCount: number;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onDateChange: (value: string) => void;
}

export const ObjectionFilters: React.FC<ObjectionFiltersProps> = ({
  searchTerm,
  statusFilter,
  selectedDate,
  visibleCount,
  totalCount,
  onSearchChange,
  onStatusChange,
  onDateChange,
}) => (
  <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="lg:col-span-2 relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text"
          placeholder="Search by case number, title, advocate..."
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <div className="relative">
        <select
          value={statusFilter}
          onChange={(event) => onStatusChange(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
        >
          <option value="all">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
        <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
      </div>

      <div>
        <input
          type="date"
          value={selectedDate}
          onChange={(event) => onDateChange(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
        />
      </div>
    </div>

    <div className="mt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4" />
        <span>
          Showing {visibleCount} of {totalCount} requests
        </span>
      </div>
    </div>
  </div>
);
